import React from 'react';
import { isEmpty } from '../functions';

const Profile = ({ content }) => {
  return (
    <div className="profile">
      <div className="profile-text-wrap">
        <div className="profile-name">{content.name}</div>
        <div className="profile-position">{content.position}</div>
      </div>
      <div className="profile-description">
        {content.description}
        {!isEmpty(content.link) && (
          <span>
            <br />
            <br />
            링크 : <a href={content.link}>{content.link}</a>
            <br />
            <br />
          </span>
        )}
      </div>
    </div>
  );
};

export default Profile;
